import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "@/constants/routes";

import { useHideDemoKitExtraneousPages } from "../hooks/useHideDemoKitExtraneousPages";

type Props = {
  children: ReactNode;
};

/** Sends demo kit orgs away from Assets, Reports, and Pairing when the flag is on. */
export const DemoKitRestrictedPageRedirect = ({ children }: Props) => {
  const hideDemoKitPages = useHideDemoKitExtraneousPages();

  if (hideDemoKitPages) {
    return <Navigate to={ROUTES.TRIPS} replace />;
  }

  return children;
};
